export enum StatoOrdine {
  PROVVISORIO = 'PROVVISORIO',
  DA_EVADERE = 'DA EVADERE',
  EVASO = 'EVASO',
  ANNULLATO = 'ANNULLATO',
  ATTESA_PAGAMENTO = 'ATTESA PAGAMENTO',
}

export enum StatoAcconto {
  NON_DOVUTO = 'NON DOVUTO',
  DOVUTO = 'DOVUTO',
  PAGATO = 'PAGATO',
}

export enum StatoFatturazioneOrdine {
  ANNULLATO = 'ANNULLATO',
  DA_FATTURARE = 'DA FATTURARE',
  FATTURATO = 'FATTURATO',
}
